import Alert from '../components/common/Alert';

const IGNORED_COMMISSION_REASONS = new Set([
  'feature_disabled',
  'not_external_ml_sheet',
  'internal_disabled',
  'ml_agent_not_applicable',
]);

const IGNORED_ON_CONTRACT_REASONS = new Set([
  'feature_disabled',
  'no_linked_contract',
]);

const commissionSucceeded = (comm) => Boolean(
  comm?.synced || comm?.created || comm?.action === 'created' || comm?.action === 'updated' || comm?.action === 'synced'
);

const onContractSucceeded = (oc) => Boolean(
  oc?.synced || oc?.created || oc?.recalculated || oc?.attached
);

const formatCommissionSuccess = (comm) => {
  if (comm?.message && (comm.synced || comm.created)) {
    return comm.message;
  }
  const action = comm?.action === 'updated' ? 'updated' : 'created';
  if (comm?.record_type === 'ml_agent') {
    return comm?.message || 'ML agent commission synced.';
  }
  if (comm?.external_commission_id) {
    return `External shipment commission ${comm.external_commission_id} ${action}.`;
  }
  if (comm?.commission_id) {
    return `Shipment commission ${comm.commission_id} ${action}.`;
  }
  return null;
};

const formatOnContractSuccess = (oc) => {
  if (oc?.message) return oc.message;
  const contractId = oc?.contract_id || oc?.contract_ids?.[0];
  if (!contractId) return null;
  if (oc?.attached || oc?.action === 'attached') {
    return `On Contract ${contractId} updated with this ML sheet.`;
  }
  if (oc?.recalculated || oc?.action === 'recalculated') {
    return `On Contract ${contractId} recalculated.`;
  }
  return `On Contract ${contractId} created.`;
};

/**
 * Show success/warning alerts for auto commission + on-contract side effects.
 * @returns {{ successes: string[], warnings: string[] }}
 */
export const getMlSheetAutoSyncMessages = (response) => {
  const body = response?.data || {};
  const sync = body.sync || {};
  const comm = sync.commission || body.shipment_commission;
  const oc = sync.on_contract || body.on_contract;

  const successes = [];
  const warnings = [];

  if (commissionSucceeded(comm)) {
    const msg = formatCommissionSuccess(comm);
    if (msg) successes.push(msg);
  } else if (comm?.message && !IGNORED_COMMISSION_REASONS.has(comm.reason)) {
    warnings.push(comm.message);
  }

  if (onContractSucceeded(oc)) {
    const msg = formatOnContractSuccess(oc);
    if (msg) successes.push(msg);
  } else if (oc?.reason && !IGNORED_ON_CONTRACT_REASONS.has(oc.reason) && oc?.message) {
    warnings.push(oc.message);
  }

  return { successes, warnings };
};

export const showMlSheetAutoSyncAlerts = (response, { baseSuccess = null } = {}) => {
  const { successes, warnings } = getMlSheetAutoSyncMessages(response);

  if (baseSuccess) {
    Alert.success(baseSuccess);
  }

  successes.forEach((msg) => Alert.success(msg));
  warnings.forEach((msg) => Alert.error(msg));

  return { successes, warnings };
};
